// React
import { useState, useEffect, useCallback } from 'react';

// Amplify UI
import '@aws-amplify/ui-react/styles.css';
import {
    Link,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    SelectField,
} from '@aws-amplify/ui-react';
import { callBackend } from './api.js';

export default function PreferredList({
    showHistoryFn
}) {
    const [preferred, setPreferred] = useState([]);
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [dayOfWeek, setDayOfWeek] = useState(-1);
    
    const refreshPreferredWorkouts = useCallback(async () => {
        setIsRefreshing(true); 
        const myInit = {
            day: dayOfWeek
        };

        try {
            const apiResult = await callBackend("workouts", "GET", myInit);
            setPreferred( await apiResult);
        } catch (e) {
            setPreferred("Empty");
            alert(`Error refreshing workouts: ${e}`);
        }
        setIsRefreshing(false);
    }, [dayOfWeek]);

    function refreshDate(day) {
        setDayOfWeek(day);
    }

    async function deleteFromPreferred(exercise) {
        setIsRefreshing(true); 
        console.log('in delete ' + dayOfWeek +":"+ exercise);
        const myInit = {
            body: {
                action: "removePreferred",
                day: dayOfWeek,
                exercise: exercise
            },
        };

        try {
            const apiResult = await callBackend("workouts", "PUT", myInit);
            refreshPreferredWorkouts();
            setIsRefreshing(false);
        } catch (e) {
            setIsRefreshing(false);
            setPreferred("Empty");
            alert(`Error refreshing workouts: ${e}`);
        }
    }

    useEffect(() => {
        //console.log('in useEffect', dayOfWeek);
        refreshPreferredWorkouts();
    }, [refreshPreferredWorkouts, dayOfWeek]);

    
    
    // Return table rows of instances
    function ExerciseRows() {
        return preferred.map((i) => {
            return (
                <TableRow key={i.name}>
                    <TableCell>
                        <Link 
                            onClick={(e) => showHistoryFn(i.name)}
                        >
                            {i.name}   
                        </Link>
                    </TableCell>
                    <TableCell>
                        <Link onClick={(e) => deleteFromPreferred(i.name)}
                        >
                            <img 
                                    src="/images/minus.png"
                                    alt="Delete from preferred" 
                                    height="30px" width="30px"
                                />
                        </Link>
                    </TableCell>
                </TableRow>
            );
        });
    }

    return (
        <Table highlightOnHover={true} variation="striped">
            <TableHead>
                <TableRow>
                    <TableCell as="th">
                        <SelectField 
                            label="Day of Week"
                            value={dayOfWeek}
                            disabled={isRefreshing}
                            onChange={(e) => refreshDate(e.target.value)}
                        >
                            <option value="-1">Today</option>
                            <option value="0">Sunday</option>
                            <option value="1">Monday</option>
                            <option value="2">Tuesday</option>
                            <option value="3">Wednesday</option>
                            <option value="4">Thursday</option>
                            <option value="5">Friday</option>
                            <option value="6">Saturday</option>
                        </SelectField>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <ExerciseRows />
            </TableBody>
            {/* <TableFoot>
                <TableRow>
                    <TableCell textAlign='center' backgroundColor={'white'}  >
                        <Button
                            loadingText="Refreshing..."
                            isLoading={isRefreshing}
                            onClick={() => refreshPreferredWorkouts()}
                            //style={{ marginLeft: '20px' }}
                            size="small"
                        >
                            Refresh
                        </Button>
                    </TableCell>
                </TableRow>
            </TableFoot> */}
        </Table>
        
    );
}
